



















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import AttachmentIcon from '@/components/icons/AttachmentIcon.vue';
import SendMessageIcon from '@/components/icons/SendMessageIcon.vue';

@Component({ components: { AttachmentIcon, SendMessageIcon } })
export default class Input extends Vue {
  @Prop({ default: '' }) readonly addClass!: string;
  @Prop({ default: '' }) readonly placeholder!: string;
  @Prop(Boolean) readonly isAbleToSendMsg!: boolean;

  dragover = false;
  message = '';
  readonly allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png'];

  get getClass () {
    return ['input-container', this.addClass, this.dragover ? 'drag-drop-zone' : ''];
  }
  get validMessage () {
    return this.isAbleToSendMsg && this.message.replace(/\s/g, '').length > 0 && this.message.length < 5001;
  }

  get placeHolderContent () {
    if (!this.placeholder) return this.$t('global.start_chat');
    return this.placeholder;
  }

  async selectImage (event: any) {
    if (!this.isAbleToSendMsg || !event.target.files.length) return;
    const imageFile = event.target.files[0];
    const MAX_FILE_SIZE = 5 * 1024 * 1044;
    try {
      const file = event.target.files[0];
      const attachment = {
        mime_type: file.type,
        name: file.name,
        size: file.size,
        url: window.URL.createObjectURL(file),
      };
      if (attachment.size > MAX_FILE_SIZE) {
        const dialog = this.$dialog({
          content: 'File size cannot exceed 5 MB',
          buttons: [{
            name: 'OK',
            callback: () => { dialog.close(); },
          }],
        });
        return;
      } if (!this.isValidMimeType(attachment.mime_type)) return;
      this.$emit('onFileUpload', file, attachment);
    } catch (error) {
      console.log(error);
    }
  }
  isValidMimeType (str: string) {
    return this.allowedMimeTypes.includes(str);
  }
  onSubmit () {
    if (!this.isAbleToSendMsg || !this.validMessage) return;
    this.$emit('onSubmit', this.message);
    this.message = '';
  }
  @Watch('message')
  onChange () {
    this.$emit('typing', this.message);
  }
  autoExpand (event: any) {
    const defaultHeight = 32;
    const field = event.target;
    if (!/\n/.test(this.message)) {
      field.style.height = `${defaultHeight}px`;
      return;
    };
    // Reset field height
    const curHeight = field.style.height;
    field.style.height = 'inherit';
    // Get the computed styles for the element
    const computed = window.getComputedStyle(field);
    // Calculate the height
    const height = parseInt(computed.getPropertyValue('border-top-width'), 10) +
      parseInt(computed.getPropertyValue('padding-top'), 10) +
      field.scrollHeight +
      parseInt(computed.getPropertyValue('padding-bottom'), 10) +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    field.style.height = (height > 90 && curHeight) ? curHeight : `${height}px`;
  }
}
